import type { MouseEventHandler } from 'react';

import { ScButton, type ValidSitecoreLink } from 'components/SitecoreLink';
import Text from 'components/Text';
import type { HTMLAttributes } from 'types';

interface Props extends HTMLAttributes<HTMLDivElement> {
	links: ValidSitecoreLink[];
	onChipClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
	title?: string;
}

/** Title and linked chips */
export default function MicroContentChipLinks({
	links,
	onChipClick,
	title,
	...attrs
}: Props) {
	return (
		<div {...attrs}>
			{title && (
				<Text as="p" className="my-6 font-bold">
					{title}
				</Text>
			)}
			<div className="flex flex-col items-start gap-2">
				{links.map((link) => (
					<ScButton
						key={`${link.href}-${link.text}`}
						variant="secondary"
						textAlignment="left"
						className="wrap-anywhere"
						link={link}
						onClick={onChipClick}
					>
						{link.text}
					</ScButton>
				))}
			</div>
		</div>
	);
}
MicroContentChipLinks.displayName = 'MicroContentChipLinks';
